  $(document).ready(function(){



         $(window).load(function() {
          
           $('.for-gridsrr').masonry({
               itemSelector: '.grid__item',
                horizontalOrder: true,
              });
            $('.for-gridsrr').masonry({
          // options...
              itemSelector: '.grid__item',
             horizontalOrder: true
             });
          });

    

      $('.related-items').slick({
        slidesToShow: 3,
        infinite:true,
        dots: false,
        arrows:true,
        autoplay:false,
        speed: 1500,
        autoplaySpeed:3200,
        cssEase: 'linear',
        responsive: [
          {
            breakpoint: 1320,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 3,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
           {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 561,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
      });



      // FOR PEOPLE SLIDER
       $('.slideshows').slick({
          infinite: true,
          arrows: true,
          fade:true,
          dots:false,
          slidesToShow: 1,
          speed: 1200,
          autoplay: false,
          slidesToScroll: 1,
          adaptiveHeight: true,
          cssEase: 'linear',
          prevArrow: '.people-wrap .prev',
          nextArrow: '.people-wrap .next',
          autoplaySpeed:1200
        });

      // FOR EQUAL HEIGHTS

        /* Thanks to CSS Tricks for pointing out this bit of jQuery
        https://css-tricks.com/equal-height-blocks-in-rows/
        It's been modified into a function called at page load and then each time the page is resized. One large modification was to remove the set height before each new calculation. */

        equalheight = function(container){

        var currentTallest = 0,
             currentRowStart = 0,
             rowDivs = new Array(),
             $el,
             topPosition = 0;
         $(container).each(function() {

           $el = $(this);
           $($el).height('auto')
           topPostion = $el.position().top;

           if (currentRowStart != topPostion) {
             for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
               rowDivs[currentDiv].height(currentTallest);
             }
             rowDivs.length = 0; // empty the array
             currentRowStart = topPostion;
             currentTallest = $el.height();
             rowDivs.push($el);
           } else {
             rowDivs.push($el);
             currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
          }
           for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
             rowDivs[currentDiv].height(currentTallest);
           }
         });
        }

        // FOR COLLECTION

        $(window).load(function() {
          equalheight('.for-grid .grid__item');
        });

        $(window).resize(function(){
          equalheight('.for-grid .grid__item');
        });


        // FOR HOMEPAGE FOOTER
       
        $(window).load(function() {
          equalheight('.search-temp .grid__item');
        });

        $(window).resize(function(){
          equalheight('.search-temp .grid__item');
        });

       
        // FOR PRODUCT INFO
       
        $(window).load(function() {
          equalheight('.feature-collectionsR .grid__item');
        });

        $(window).resize(function(){
          equalheight('.feature-collectionsR .grid__item');
        });

   


        // modal sticky





      // search


        $( ".skip-search" ).click(function()  {
        $( ".search-content" ).slideToggle();
        })

      // TOGGLE

        $( ".form-toggle" ).click(function()  {
        $( ".form-content" ).toggle();
        })
   
      // MOBILE MENU

   
        $('li.skip-nav').on('click', function(){
          $('.menu-content').slideToggle();
          $(this).toggleClass("active")
        })



      // filter

        $('.toggle-menu-filter').hover(function() {
            var $li = $(this);
            $('.submenu-tag', $li).stop(true, true).toggle();

        }, function() {
            var $li = $(this);
            $('.submenu-tag', $li).stop(true, true).toggle();
        });

      // account menu
 
        
    

      // ACCORDION FOOTER

        var acc = document.getElementsByClassName("accordion");
        var i;

        for (i = 0; i < acc.length; i++) {
          acc[i].addEventListener("click", function() {
            this.classList.toggle("active");
            var panel = this.nextElementSibling;
            if (panel.style.maxHeight){
              panel.style.maxHeight = null;
            } else {
              panel.style.maxHeight = panel.scrollHeight + "px";
            } 
          });
        }

      // BACK TO TOP

        if ($('#back-to-top').length) {
          var scrollTrigger = 180, // px
              backToTop = function () {
                  var scrollTop = $(window).scrollTop();
                  if (scrollTop > scrollTrigger) {
                      $('#back-to-top').addClass('show');
                  } else {
                      $('#back-to-top').removeClass('show');
                  }
              };
          backToTop();
          $(window).on('scroll', function () {
              backToTop();
          });
          $('#back-to-top').on('click', function (e) {
              e.preventDefault();
              $('html,body').animate({
                  scrollTop: 0
              }, 700);
          });
        }

        // video
        $('.ytvideo[data-video]').one('click', function() {

          var $this = jQuery(this);
          var width = $this.attr("width");
          var height = $this.attr("height");
          
        $this.html('<iframe src="https://www.youtube.com/embed/' + $this.data("video") + '?autoplay=1"></iframe>');
      });


           //toggle the component with class accordion_body
          jQuery(".accordion_head").click(function() {
            if (jQuery('.accordion_body').is(':visible')) {
              jQuery(".accordion_body").slideUp(300);
              // $(".plusminus").text('+');
              jQuery(".accord").removeClass('active');
            }
            if (jQuery(this).next(".accordion_body").is(':visible')) {
              jQuery(this).next(".accordion_body").slideUp(300);
              // $(this).children(".plusminus").text('+');
              jQuery(this).parent(".accord").removeClass('active');
            } else {
              jQuery(this).next(".accordion_body").slideDown(300);
              // $(this).children(".plusminus").text('-');
              jQuery(this).parent(".accord").addClass('active');
            }
          });






        
  });
// END